import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
import React from 'react';
export const A = ({ className, ...props }) => {
    return _jsx("a", { className: clsx('dt-a', className), ...props });
};
export const P = ({ className, ...props }) => {
    return _jsx("p", { className: clsx('dt-text', className), ...props });
};
export const H1 = ({ className, ...props }) => {
    return _jsx("h1", { className: clsx('dt-text', className), ...props });
};
export const H2 = ({ className, ...props }) => {
    return _jsx("h2", { className: clsx('dt-text', className), ...props });
};
export const H3 = ({ className, ...props }) => {
    return _jsx("h3", { className: clsx('dt-text', className), ...props });
};
export const H4 = ({ className, ...props }) => {
    return _jsx("h4", { className: clsx('dt-text', className), ...props });
};
export const H5 = ({ className, ...props }) => {
    return _jsx("h5", { className: clsx('dt-text', className), ...props });
};
export const Input = ({ className, ...props }) => {
    return _jsx("input", { className: clsx('dt-text', className), ...props });
};
export const Textarea = ({ className, ...props }) => {
    return _jsx("textarea", { className: clsx('dt-textarea', className), ...props });
};
export const Img = ({ className, ...props }) => {
    return _jsx("img", { className: clsx('dt-img', className), ...props });
};
export const Label = ({ className, ...props }) => {
    return _jsx("label", { className: clsx('dt-label', className), ...props });
};
export const ButtonBase = React.forwardRef(({ className, ...props }, ref) => {
    return (_jsx("button", { ref: ref, className: clsx('dt-button', className), ...props }));
});
ButtonBase.displayName = 'ButtonBase';
//# sourceMappingURL=preflighted.js.map